/* eslint-disable */
const awsmobile = {
  "aws_project_region": "ap-southeast-2",
  "aws_cognito_identity_pool_id": "ap-southeast-2:a31d544f-47b5-4f73-94dc-a05d455ef66e",
  "aws_cognito_region": "ap-southeast-2",
  "aws_user_pools_id": "ap-southeast-2_4rD9ysoze",
  "aws_user_pools_web_client_id": "1hvkmqajoi4cvrpu6a0ph2imov",
  "oauth": {},
  "aws_appsync_graphqlEndpoint": "https://bidi67lhjnhdhkuk4skifsbfyy.appsync-api.ap-southeast-2.amazonaws.com/graphql",
  "aws_appsync_region": "ap-southeast-2",
  "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
  "aws_cloud_logic_custom": [
      {
          "name": "stripeapi",
          "endpoint": "https://uw2bmyifch.execute-api.ap-southeast-2.amazonaws.com/prod",
          "region": "ap-southeast-2"
      },
      {
          "name": "sendEmail",
          "endpoint": "https://rj1nkhs5b5.execute-api.ap-southeast-2.amazonaws.com/prod",
          "region": "ap-southeast-2"
      }
  ],
  "aws_user_files_s3_bucket": "casenoterappv28735cd12a3a2490f870417f3694c643e170230-prod",
  "aws_user_files_s3_bucket_region": "ap-southeast-2"
};


export default awsmobile;
